import { Link } from "react-router-dom";

export const Logo = ({ to = "/", testId = "brand-logo" }) => (
  <Link to={to} data-testid={testId} className="group flex items-center gap-2.5">
    <span className="relative grid h-9 w-9 place-items-center rounded-xl bg-emerald-500 text-[#06110c] shadow-[0_0_24px_rgba(16,185,129,0.35)] transition-transform duration-300 group-hover:rotate-6">
      <span className="font-display text-lg font-extrabold leading-none">R</span>
      <span className="absolute -right-1 -top-1 h-2.5 w-2.5 rounded-full bg-amber-400 ring-2 ring-[#0b0f17]" />
    </span>
    <span className="font-display text-lg font-bold tracking-tight text-white">
      Raphanex<span className="text-emerald-400">.</span>
      <span className="ml-1 text-sm font-medium text-slate-400">store</span>
    </span>
  </Link>
);
